import { InterstitialPage, urlUtil } from '@cmg/common';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import cookieManager from '../../../common/util/cookieManager';
import routeFactory from '../../../common/util/routeFactory';
import { ErrorCode } from '../error/constants';
import IdentityProviderLogin from './components/identityProviderLogin/IdentityProviderLogin';
import LocalLogin from './components/localLogin/LocalLogin';
import { fetchLoginInfo, selectLoginInfo, selectLoginInfoError } from './ducks';

export const LoginRouteComponent: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const loginInfo = useSelector(selectLoginInfo);
  const loginInfoError = useSelector(selectLoginInfoError);
  const xsrfToken = cookieManager.readXsrfToken();
  const { returnUrl } = urlUtil.queryParse<{ returnUrl?: string }>(location.search);

  useEffect(() => {
    if (returnUrl) {
      dispatch(fetchLoginInfo({ returnUrl }));
    }
  }, [dispatch, returnUrl]);

  // Somehow the user ended up here without first redirecting to the identity service. Taking them to a private route that will trigger the oidc flow.
  if (!xsrfToken || !returnUrl) {
    return <Navigate to={routeFactory.profile.getUrlPath()} replace />;
  }

  if (!loginInfo) {
    return <InterstitialPage />;
  }

  if (loginInfoError) {
    return (
      <Navigate
        to={routeFactory.error.getUrlPath({ errorCode: ErrorCode.LOGIN_PREREQUISITE })}
        replace
      />
    );
  }

  if (loginInfo.localLoginEnabled) {
    return <LocalLogin returnUrl={returnUrl} />;
  }

  return <IdentityProviderLogin identityProviders={loginInfo.externalProviders} />;
};

export default LoginRouteComponent;
